import { Navigate, Outlet } from "react-router-dom";
import { useConsoleAuthStore } from "store/useConsoleAuthStore";

// 콘솔 "관리자 메뉴" (계정 CRUD) 접근 가능한 a_id 화이트리스트
export const SUPER_ADMIN_IDS = ["admin", "abcdkdh"];

export function SuperAdminGuard() {
    const a_id = useConsoleAuthStore(state => state.a_id);

    if (!a_id || !SUPER_ADMIN_IDS.includes(a_id)) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}
